import type { SRT_RowData } from '../types'
import type { VirtOptions } from './virt'

import React from 'react'
import { flushSync } from 'react-dom'

import { Virt } from './virt'

const useIsomorphicLayoutEffect =
	typeof document !== 'undefined' ? React.useLayoutEffect : React.useEffect

export function useVirt<T extends SRT_RowData>(options: VirtOptions<T>) {
	const rerender = React.useReducer(() => ({}), {})[1]
	const resolvedOptions = {
		...options,
		onChange: (instance: Virt<T>, sync: boolean) => {
			if (sync) {
				// eslint-disable-next-line @eslint-react/dom/no-flush-sync
				flushSync(rerender)
			} else {
				rerender()
			}
			options.onChange?.(instance, sync)
		},
	}
	const [instance] = React.useState(() => new Virt<T>(resolvedOptions))
	instance.setOptions(resolvedOptions)
	React.useEffect(() => {
		if (!options.enabled) return

		return instance.didMount()
	}, [])

	useIsomorphicLayoutEffect(() => {
		if (!options.enabled) return

		return instance.willUpdate()
	})

	return instance
}
